import { MutableRefObject } from 'react';

import { Session } from 'bundles/utils';

export const triggerSession = (action: string, refForm: MutableRefObject<HTMLFormElement | null>) => {
  const session = new Session(refForm.current);
  action === 'start' ? session.keepAlive().startHeartBeat() : session.signOut();
};
